import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useReactiveVar } from '@apollo/client';

import { InternalLinks } from '../../../../constants';
import { ResetPassword as ResetPasswordView } from './reset-password';
import { REQUEST_CODE_TIME } from '../../../../constants/one-time-pin';
import { usePersistedTimer, getLastActivePhone } from '../../../../utils/persisted-timer';
import { setCaptcha } from '../../../../graphql/configuration/configuration.cache';

export const ResetPassword = (): JSX.Element => {
  const navigate = useNavigate();

  const handleResetPasswordDone = () => {
    navigate(InternalLinks.login, { state: { hasPreviousLocation: true } });
  };

  const [initialPhone] = useState(() => getLastActivePhone(REQUEST_CODE_TIME));
  const { time, start, status } = usePersistedTimer({
    phone: initialPhone,
    duration: REQUEST_CODE_TIME,
  });

  const captcha = useReactiveVar(setCaptcha);

  return (
    <ResetPasswordView
      onDone={handleResetPasswordDone}
      externalState={{ time, start, status, captcha }}
    />
  );
};
